import { Stack, type Theme } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

const MOBILE_BREAKPOINT = 576;

const MOBILE_TABLE_SCALE = 0.8;

const DESKTOP_TABLE_SCALE = 0.9;

export const Root = styled(Stack)`
  position: relative;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    zoom: ${MOBILE_TABLE_SCALE};
  }

  @media (min-width: ${MOBILE_BREAKPOINT + 1}px) {
    zoom: ${DESKTOP_TABLE_SCALE};
  }
`;

export const getGroupedRowBackground = (theme: Theme) =>
  theme.palette.mode === "dark" ? "#0A0A0A" : "#F5F5F5";

export const getNotGroupedRowBorder = (theme: Theme) =>
  `0.15rem solid ${alpha(theme.palette.primary.main, 0.1)}`;

export const getMarketsDataGridStyles = (theme: Theme) => ({
  width: "100%",
  border: "none",
  borderRadius: 0,
  margin: "0 !important",

  ".MuiDataGrid-columnHeaders": { overflow: "hidden", opacity: 0 },

  ".MuiDataGrid-columnSeparator": { visibility: "hidden" },

  ".MuiDataGrid-cell--withRightBorder": {
    borderRight: "none",
  },

  ".grouped > .MuiDataGrid-cell--pinnedLeft, .grouped": {
    background: getGroupedRowBackground(theme),
  },

  ".note > .MuiDataGrid-cell--pinnedLeft": {
    overflow: "visible",
  },

  ".not-grouped-market": {
    borderBottom: getNotGroupedRowBorder(theme),

    ".MuiDataGrid-cell--pinnedLeft": {
      borderBottom: getNotGroupedRowBorder(theme),
    },
  },
});
